import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("h1", null, "Wikipedia Charts", -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("p", { class: "subtitle" }, "Indirectly from Wikipedia, the free encyclopedia", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createVNode("strong", null, "Wikipedia Charts"),
  /*#__PURE__*/_createTextVNode(" is a "),
  /*#__PURE__*/_createVNode("a", { href: "https://en.wikipedia.org/wiki/Website" }, "website"),
  /*#__PURE__*/_createTextVNode(" that shows the top 100 visited pages on the "),
  /*#__PURE__*/_createVNode("a", { href: "https://en.wikipedia.org/wiki/English_language" }, "English"),
  /*#__PURE__*/_createTextVNode(" version of "),
  /*#__PURE__*/_createVNode("a", { href: "https://en.wikipedia.org/wiki/Wikipedia" }, "Wikipedia"),
  /*#__PURE__*/_createTextVNode(" on any given day. ")
], -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("p", null, " Each entry in the list displays the page’s rank, the difference between it’s ranking on that day compared to the day before (in the “Change” column), and the number of times that page was viewed. ", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" A page is listed in "),
  /*#__PURE__*/_createVNode("a", { href: "https://en.wikipedia.org/wiki/Bold" }, "bold"),
  /*#__PURE__*/_createTextVNode(" and marked with three arrows (⬆︎⬆︎⬆︎) when it wasn’t in the top 1,000 pages on Wikipedia on the day before, meaning it became very "),
  /*#__PURE__*/_createVNode("span", { nowrap: "" }, [
    /*#__PURE__*/_createTextVNode("popular"),
    /*#__PURE__*/_createVNode("sup", null, [
      /*#__PURE__*/_createTextVNode("["),
      /*#__PURE__*/_createVNode("em", null, [
        /*#__PURE__*/_createVNode("a", { href: "https://en.wikipedia.org/wiki/Wikipedia:Citation_needed" }, "citation needed")
      ]),
      /*#__PURE__*/_createTextVNode("]")
    ])
  ]),
  /*#__PURE__*/_createTextVNode(" very abruptly. This usually means it's related to a major news event or it’s a new "),
  /*#__PURE__*/_createVNode("a", { href: "https://en.wikipedia.org/wiki/Netflix" }, "Netflix"),
  /*#__PURE__*/_createTextVNode(" show. ")
], -1)
const _hoisted_6 = { class: "date-selector-and-leaderboard" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { id: "spacer" }, null, -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_error_message = _resolveComponent("error-message")
  const _component_date_selector = _resolveComponent("date-selector")
  const _component_leaderboard = _resolveComponent("leaderboard")

  return (_openBlock(), _createBlock("main", null, [
    _hoisted_1,
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    (_ctx.articles.status === 'error')
      ? (_openBlock(), _createBlock(_component_error_message, {
          key: 0,
          date: _ctx.date
        }, null, 8, ["date"]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_6, [
      (_ctx.date)
        ? (_openBlock(), _createBlock(_component_date_selector, {
            key: 0,
            date: _ctx.date,
            "max-date": _ctx.maxDate
          }, null, 8, ["date", "max-date"]))
        : _createCommentVNode("", true),
      _createVNode(_component_leaderboard, { articles: _ctx.articles }, null, 8, ["articles"])
    ]),
    _hoisted_7
  ]))
}